<template>
    <section class="flex flex-col text-base">
        <PageHeader wide>
            <h1>{{ $t("Manufacturer.ManufacturerHeader") }}</h1>
        </PageHeader>
        <ManufacturerList />
    </section>
</template>
<script setup>
const { t } = useI18n();

useSeoMeta({
    title: t("Manufacturer.ManufacturerAllTitle"),
    ogTitle: t("Manufacturer.ManufacturerAllTitle"),
    description: t("Manufacturer.MetaDescriptionAllFormat"),
    ogDescription: t("Manufacturer.MetaDescriptionAllFormat"),
});
</script>
